import { TournamentStatus } from '@okletsplay/core';
import { sessionSelector } from 'app/store/session/selectors';
import isEmpty from 'lodash/isEmpty';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { currentTournamentSelector } from '../store/current-tournament/selectors';

export const useTournamentDetails = () => {
  const tournament = useSelector(currentTournamentSelector.tournament);
  const currentUser = useSelector(sessionSelector.activeUser);

  const isCanceledTournament = useMemo(
    () => tournament?.status === TournamentStatus.Canceled,
    [tournament]
  );

  const isPendingTournament = useMemo(
    () => tournament?.status === TournamentStatus.Pending,
    [tournament]
  );

  const isFinishedTournament = useMemo(
    () => tournament?.status === TournamentStatus.Finished,
    [tournament]
  );

  const isCheckinTournament = useMemo(
    () => tournament?.status === TournamentStatus.Checkin,
    [tournament]
  );

  const isLiveTournament = useMemo(
    () => tournament?.status === TournamentStatus.Live,
    [tournament]
  );

  const isTournamentEditable = useMemo(() => {
    if (isEmpty(tournament)) {
      return true;
    }

    return [TournamentStatus.Pending, TournamentStatus.Checkin].includes(tournament.status);
  }, [tournament]);

  const isCurrentUserPlayer = useMemo(() => {
    return !!tournament?.teams
      ?.flatMap((team) => team?.players ?? [])
      ?.find((player) => player?.userId === currentUser?.userId);
  }, [tournament, currentUser]);

  const isFull = useMemo(() => {
    return tournament?.teams?.length === tournament?.teamsSettings?.maxTeams;
  }, [tournament]);

  const isCurrentUserJoined = useMemo(() => {
    return tournament?.teams
      ?.flatMap((team) => team?.players ?? [])
      ?.find((player) => player?.userId === currentUser?.userId);
  }, [tournament, currentUser]);

  return {
    isFinishedTournament,
    isCanceledTournament,
    isCurrentUserJoined,
    isCurrentUserPlayer,
    isPendingTournament,
    isTournamentEditable,
    isCheckinTournament,
    isLiveTournament,
    isFull,
  };
};
